import React from 'react';
import { PageWithAppcues } from 'packages/helpers/RouteWithAppcues';
import Designs from '../designs/Designs';

const SharedWithMeContainer = () => (
    <PageWithAppcues>
        <Designs isSharedWithMe />
    </PageWithAppcues>
);
export default SharedWithMeContainer;
